// Tab Collections — lazy init + accessible tabs + simple carousel controls

(function () {
  const qs = (sel, ctx = document) => ctx.querySelector(sel);
  const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function initSection(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = "true";

    // Tabs
    const tabs = qsa('.tc__tab', root);
    const panels = qsa('.tc__panel', root);
    if (tabs.length) {
      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => activateTab(idx));
        tab.addEventListener('keydown', (e) => {
          const k = e.key;
          let i = tabs.indexOf ? tabs.indexOf(tab) : idx;
          if (k === 'ArrowRight') { e.preventDefault(); tabs[(i + 1) % tabs.length].focus(); }
          if (k === 'ArrowLeft')  { e.preventDefault(); tabs[(i - 1 + tabs.length) % tabs.length].focus(); }
          if (k === 'Home')       { e.preventDefault(); tabs[0].focus(); }
          if (k === 'End')        { e.preventDefault(); tabs[tabs.length - 1].focus(); }
          if (k === 'Enter' || k === ' ') { e.preventDefault(); tab.click(); }
        });
      });

      function activateTab(i) {
        tabs.forEach((t, idx) => {
          const active = idx === i;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
          panels[idx]?.toggleAttribute('hidden', !active);
        });
      }
    }

    // Carousel controls
    qsa('[data-scroller]', root).forEach((scroller) => {
      const wrap = scroller.closest('.tc__viewport');
      const btnPrev = qs('.tc__nav--prev', wrap);
      const btnNext = qs('.tc__nav--next', wrap);
      const updateButtons = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
        btnPrev && (btnPrev.disabled = scroller.scrollLeft <= 0);
        btnNext && (btnNext.disabled = scroller.scrollLeft >= maxScroll);
      };
      updateButtons();
      scroller.addEventListener('scroll', () => requestAnimationFrame(updateButtons));
      window.addEventListener('resize', () => requestAnimationFrame(updateButtons));

      const step = () => Math.max(scroller.clientWidth * 0.9, 200);
      btnPrev && btnPrev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
      btnNext && btnNext.addEventListener('click', () => scroller.scrollBy({ left:  step(), behavior: 'smooth' }));
    });
  }

  // Lazy init when section is near viewport
  function observe() {
    const sections = qsa('.tc[data-defer-init="true"]');
    if (!('IntersectionObserver' in window)) {
      sections.forEach(initSection);
      return;
    }
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          initSection(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { root: null, rootMargin: '200px 0px', threshold: 0.01 });

    sections.forEach(s => io.observe(s));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();